import React, { useState, useRef, useEffect } from "react";
import { Button, Icon } from "../../../_components";
import { calendarTemplates, parseCalendar } from "../../../_helpers";
import { gregorianCalendar } from "../../../_helpers/_calendars";
import ReactTooltip from "react-tooltip";

import {
  WelcomePage,
  CalendarTemplatePage,
  CalendarMonthsPage,
  CalendarTimePage,
  DefaultTimeUnitPage,
  ChronicleStartPage,
  DefaultMapPage,
  DefaultCoverPage,
  TimelineSetupPage,
  SetupCompletePage,
  SubmittingPage,
} from "./";

const formPages = [
  { title: "Welcome", icon: "", component: WelcomePage },
  { title: "Calendar Template", icon: "", component: CalendarTemplatePage },
  { title: "Calendar Months", icon: "", component: CalendarMonthsPage },
  { title: "Calendar Time", icon: "", component: CalendarTimePage },
  { title: "Default Time Unit", icon: "", component: DefaultTimeUnitPage },
  { title: "Chronicle Start Date", icon: "", component: ChronicleStartPage },
  { title: "Default Map", icon: "", component: DefaultMapPage },
  { title: "Default Cover Image", icon: "", component: DefaultCoverPage },
  { title: "Timeline Setup", icon: "", component: TimelineSetupPage },
  { title: "Submitting", icon: "", component: SubmittingPage },
  { title: "Setup Complete", icon: "", component: SetupCompletePage },
];

export function WelcomeWizard() {
  const [currentPage, setPage] = useState(0);
  const [showNavigation, setShowNavigation] = useState(true);
  const [isBackEnabled, setBackEnabled] = useState(true);
  const [isNextEnabled, setNextEnabled] = useState(true);
  const [store, setStore] = useState({
    template: "gregorian",
    months: gregorianCalendar.months || [],
    time: parseCalendar(gregorianCalendar, "form").time || {},
    startDate: "0",
    cover: null,
    map: null,
    defaultUnit: "year",
    unitCount: 1000,
    timelineName: "",
    timelinePrivate: false,
    timelineSubgroups: [],
  });

  const getCalendar = (storeObj, format = "api") => {
    if (storeObj === undefined) {
      storeObj = store;
    }
    const newCalendar = {
      time: { ...storeObj.time },
      months: storeObj.months.map((m) => ({ ...m })),
    };
    // parseCalendar??
    return parseCalendar(newCalendar, format);
  };

  //Navigation methods
  const handleNavNext = async (ev) => {
    if (formRef && formRef.current) {
      // console.log("Running manual submit");
      await formRef.current.requestSubmit();
    }
    if (currentPage >= formPages.length) return; // trigger true submit here
    if (!isNextEnabled) return;
    setPage((p) => p + 1);
  };
  const handleNavBack = async () => {
    if (formRef && formRef.current) {
      // console.log("Running manual submit");
      await formRef.current.requestSubmit();
    }
    if (currentPage <= 0) return;
    if (!isBackEnabled) return;
    setPage((p) => p - 1);
  };

  const disableNavigation = () => {
    setBackEnabled(false);
    setNextEnabled(false);
  };

  const enableNavigation = () => {
    //These need checks, based on currentPage and number of pages
    // to prevent exceeding min/max number of pages.
    setBackEnabled(true);
    setNextEnabled(true);
  };

  const nextTab = () => {
    setPage((p) => p + 1);
  };

  //Form Initialization
  // const formMethods = useForm({
  //   defaultValues: {
  //     test: "",
  //   },
  //   shouldUnregister: false,
  // });

  const WizardPage = formPages[currentPage].component;
  const formRef = useRef();

  const handleSubForm = (formData) => {
    const isTemplate = formData.hasOwnProperty("template");
    if (isTemplate) {
      // console.log("field updating is template!");
      const { template } = formData;
      if (
        template !== store.template &&
        calendarTemplates[template] !== undefined
      ) {
        // console.log(
        //   "Template chosen does not match existing selection. Getting new calendar"
        // );
        const parsedCalendar = parseCalendar(
          calendarTemplates[template],
          "form"
        );
        formData.months = [...parsedCalendar.months];
        formData.time = { ...parsedCalendar.time };
      }
    }
    // console.log("Form Data", formData);
    setStore({
      ...store,
      ...formData,
    });
  };

  const navMethods = {
    disableNavigation,
    enableNavigation,
    setShowNavigation,
    nextTab,
  };
  console.log("==== Wizard Root Render!");
  useEffect(() => {
    ReactTooltip.rebuild();
  }, [currentPage]);

  const tooltipID = "chronos-welcome-wizard-tooltip";
  return (
    <div className="chronos-setup-wizard chronos-form">
      <div className="chronos-setup-wizard-content">
        <WizardPage
          onSubmit={handleSubForm}
          formRef={formRef}
          store={store}
          getCalendar={getCalendar}
          navMethods={navMethods}
          tooltipID={tooltipID}
        />
      </div>
      {showNavigation && (
        <div className="chronos-form-controls chronos-form-controls-affixed">
          <div className="form-control-btns">
            <Button
              color="primary"
              size="xs"
              disabled={!isBackEnabled || currentPage <= 0}
              onClick={handleNavBack}
            >
              <Icon icon="fas fa-chevron-left fa-fw" />
              &nbsp;Back
            </Button>
            <Button
              color={currentPage < 8 ? "primary" : "success"}
              size="xs"
              disabled={!isNextEnabled || currentPage + 1 >= formPages.length}
              onClick={handleNavNext}
            >
              {currentPage < 8 && (
                <React.Fragment>
                  Next&nbsp;
                  <Icon icon="fas fa-chevron-right fa-fw" />
                </React.Fragment>
              )}
              {currentPage >= 8 && (
                <React.Fragment>
                  <Icon icon="fas fa-save fa-fw" />
                  &nbsp;Save
                </React.Fragment>
              )}
            </Button>
          </div>
          {showNavigation && (
            <WizardProgress pageCount={10} pageIndex={currentPage} />
          )}
        </div>
      )}

      <ReactTooltip id={tooltipID} effect="solid" />
    </div>
  );
}

function WizardProgress({ pageCount, pageIndex }) {
  const percentComplete = ((pageIndex + 1) / pageCount) * 100;
  const innerWidth = { width: `${percentComplete}%` };
  // const innerWidth = { width: `${40}%` };
  return (
    <div className="chronos-progress-bar-outer chronos-setup-progress">
      <div className="chronos-progress-bar-inner" style={innerWidth} />
      <span className="chronos-progress-value">
        {pageIndex + 1}/{pageCount}
      </span>
    </div>
  );
}
